import { useEffect, useState } from 'react';

/** "UFC 333: Volkanovski vs. Evloev" -> { card: 'UFC 333', red: 'Volkanovski', blue: 'Evloev' } */
export function splitEventName(name = '') {
  const [cardPart, boutPart] = name.includes(':') ? name.split(/:(.+)/) : [name, ''];
  const bout = (boutPart || '').trim();
  const m = bout.match(/^(.*?)\s+vs\.?\s+(.*)$/i);
  return {
    card: cardPart.trim(),
    bout,
    red: m ? m[1].trim() : '',
    blue: m ? m[2].trim() : '',
  };
}

/** Ticking countdown to an ISO date. Returns null once the time has passed. */
export function useCountdown(iso) {
  const target = iso ? new Date(iso).getTime() : NaN;
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (Number.isNaN(target)) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);
  if (Number.isNaN(target)) return null;
  const ms = target - now;
  if (ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

export const pad2 = (n) => String(n).padStart(2, '0');

export function formatLockTime(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
